<template>
    <div>
        <el-dialog :title="formData.state==3?'完成任务':'取消任务'" :visible.sync="showForm" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="formData">
                <el-form-item :label="formData.state==3?'备注内容':'取消原因'" prop="comment">
                    <el-input type="textarea" rows="6" v-model="formData.comment" placeholder="请输入跟进内容"
                        clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showForm = false">取消</el-button>
                <el-button type="primary" @click="savelog">确定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import taskApi from "@/script/api/taskApi";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";

import { validateIdNo } from "@/script/validator";

export default {
    components: {},

    filters: {

    },
    data() {
        return {
            showForm: false, 
            formData: {
                taskId: '',
                handleId: '',
                comment: '',
                state:'',
            }
        }
    },
    methods: {
        showOper(taskRow,state) {
            this.showForm = true;
            this.formData = {
                taskId: taskRow.id,
                handleId: globalData.userInfo.id,
                comment: '',//3完成，4取消
                state:state
            }
        },
        savelog() {
            if (this.formData.comment == ''&&this.formData.state==4) {
                this.$message.error('请填写原因');
                return;
            }

            taskApi.$axioFinishOrCancelTask(this.formData).then(res => { 
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showForm = false;
                    this.$parent.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            })
        }
    }
};
</script>

<style scoped></style>
  